const Moon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="13"
      height="12"
      viewBox="0 0 13 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.82764 1.70401C4.05625 1.57258 4.30625 1.80902 4.24365 2.06534C4.15038 2.44543 4.10111 2.84301 4.10107 3.25186C4.10107 6.00259 6.33068 8.2333 9.08154 8.2333C9.4905 8.2333 9.88796 8.18322 10.2681 8.08975C10.5245 8.02686 10.7613 8.27701 10.6294 8.50577C9.76895 9.99636 8.1589 10.9999 6.31396 10.9999C3.56333 10.9997 1.33357 8.76997 1.3335 6.01944C1.3335 4.17473 2.33721 2.56458 3.82764 1.70401ZM9.17334 0.773344C9.23632 0.631704 9.43067 0.631704 9.49365 0.773344L10.1499 2.39639C10.1675 2.43576 10.1979 2.46795 10.2358 2.48623L11.5649 3.16787C11.7008 3.23349 11.7009 3.43447 11.5649 3.49991L10.2358 4.18057C10.1979 4.19885 10.1675 4.23104 10.1499 4.27041L9.49365 5.89346C9.43067 6.0351 9.23632 6.0351 9.17334 5.89346L8.51807 4.27041C8.50047 4.23097 8.46915 4.19884 8.43115 4.18057L7.10205 3.49991C6.96603 3.43451 6.96631 3.23354 7.10205 3.16787L8.43115 2.48623C8.46915 2.46797 8.50047 2.43584 8.51807 2.39639L9.17334 0.773344Z" />
    </svg>
  );
};

export default Moon;
